import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/Dashboard";
import Agents from "../pages/Admin/agents/Agents";
import RegisteredStudents from "../pages/Admin/agents/RegisteredStudents";
import RegisteredClients from "../pages/Admin/agents/RegisteredClients";
import OrganizerManagement from "../pages/Admin/media/organizer/OrganizerManagement";
import CreateEditOrganizer from "../pages/Admin/media/organizer/CreateEditOrganizer";
import CreateEvent from "../pages/Admin/media/events/CreateEvent";
import EditEvent from "../pages/Admin/media/events/EditEvent";
import EventDetails from "../pages/Admin/media/events/EventDetails";
import EventAnalytics from "../pages/Admin/media/events/EventAnalytics";
import EventsManagement from "../pages/Admin/media/events/EventsManagement";
import EventAttendees from "../pages/Admin/media/events/EventAttendees";
import CreateConferenceTradeMission from "../pages/Admin/media/conferences-trade-missions/CreateConferenceTradeMission";
import EditConferenceTradeMission from "../pages/Admin/media/conferences-trade-missions/EditConferenceTradeMission";
import ConferenceTradeMission from "../pages/Admin/media/conferences-trade-missions/ConferenceTradeMission";
import Conferences from "../pages/Admin/media/conferences-trade-missions/Conferences";
import TradeMissions from "../pages/Admin/media/conferences-trade-missions/TradeMissions";
import ViewConference from "../pages/Admin/media/conferences-trade-missions/ViewConference";
import ViewTradeMission from "../pages/Admin/media/conferences-trade-missions/ViewTradeMission";
import ConferenceAnalytics from "../pages/Admin/media/conferences-trade-missions/ConferenceAnalytics";
import TradeMissionAnalytics from "../pages/Admin/media/conferences-trade-missions/TradeMissionAnalytics";
import ConferenceTradeAttendees from "../pages/Admin/media/conferences-trade-missions/ConferenceTradeAttendees";
import ConferenceAttendees from "../pages/Admin/media/conferences-trade-missions/ConferenceAttendees";
import TradeMissionAttendees from "../pages/Admin/media/conferences-trade-missions/TradeMissionAttendees";
import ProviderManagement from "../pages/Admin/providers/ProviderManagement";

// Insurance Policy Management
import { InsurancePolicyManagement, PolicyDetailView } from "../pages/Admin/insurance_policies";
import ClaimsManagement from "../pages/Admin/claims/ClaimsManagement";
import ApprovedClaims from "../pages/Admin/claims/ApprovedClaims";
import RejectedClaims from "../pages/Admin/claims/RejectedClaims";
import PurchasesManagement from "../pages/Admin/purchases/PurchasesManagement";

// Import other admin pages as they are created
// import Users from "../pages/admin/Users";
// import Transportation from "../pages/admin/Transportation";
// import Providers from "../pages/admin/Providers";
// import Payments from "../pages/admin/Payments";
// import Analytics from "../pages/admin/Analytics";
// import Reports from "../pages/admin/Reports";
// import Notifications from "../pages/admin/Notifications";
// import Settings from "../pages/admin/Settings";
// import Help from "../pages/admin/Help";

export default function AdminRoutes() {
  return (
    <Routes>
      {/* Dashboard */}
      <Route path="dashboard" element={<Dashboard />} />

      {/* Agents Management */}
      <Route
        path="agents/registered-students"
        element={<RegisteredStudents />}
      />
      <Route
        path="agents/registered-clients"
        element={<RegisteredClients />}
      />
      <Route
        path="agents/*"
        element={
          <Agents/>
        }
      />

      {/* User Management */}
      <Route
        path="users/*"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">User Management</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Insurance Policy Management */}
      <Route path="insurance-policies" element={<InsurancePolicyManagement />} />
      <Route path="insurance-policies/:policy_slug" element={<PolicyDetailView />} />
      
      {/* Claims Management */}
      <Route path="insurance/claims" element={<ClaimsManagement />} />
      <Route path="insurance/approved" element={<ApprovedClaims />} />
      <Route path="insurance/rejected" element={<RejectedClaims />} />

      {/* Transportation */}
      <Route
        path="transportation/*"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Transportation Management</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Providers */}
      <Route
        path="providers/*"
        element={
          <ProviderManagement />
        }
      />

      {/* Purchases */}
      <Route path="purchases" element={<PurchasesManagement />} />

      {/* Payments */}
      <Route
        path="payments/*"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Payment Management</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Analytics */}
      <Route
        path="analytics/*"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Analytics</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Reports */}
      <Route
        path="reports/*"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Reports</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Notifications */}
      <Route
        path="notifications"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Notifications</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Settings */}
      <Route
        path="settings/*"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Settings</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Help & Support */}
      <Route
        path="help/*"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Help & Support</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Media Library Routes */}
      <Route path="media/organizer" element={<OrganizerManagement />} />
      <Route path="media/organizer/create" element={<CreateEditOrganizer />} />
      <Route path="media/organizer/edit/:id" element={<CreateEditOrganizer />} />

      {/* Events Routes */}
      <Route path="media/events/create" element={<CreateEvent />} />
      <Route path="media/events/edit/:event_slug" element={<EditEvent />} />
      <Route path="media/events/view/:event_slug" element={<EventDetails />} />
      <Route path="media/events/:event_slug/analytics" element={<EventAnalytics />} />
      <Route path="media/events/:event_slug/attendees" element={<EventAttendees />} />
      <Route path="media/events" element={<EventsManagement />} />

      {/* Conferences & Trade Missions Routes */}
      <Route path="media/conferences" element={<Conferences />} />
      <Route path="media/trade-missions" element={<TradeMissions />} />
      {/* Keep old route for backward compatibility */}
      <Route path="media/conference" element={<ConferenceTradeMission />} />
      <Route path="media/conferences-trade-missions/create" element={<CreateConferenceTradeMission />} />
      <Route path="media/conferences-trade-missions/edit/:event_slug" element={<EditConferenceTradeMission />} />
      <Route path="media/conference/view/:event_slug" element={<ViewConference />} />
      <Route path="media/conferences-trade-missions/view-conference/:event_slug/analytics" element={<ConferenceAnalytics />} />
      <Route path="media/trade-mission/view/:event_slug" element={<ViewTradeMission />} />
      <Route path="media/conferences-trade-missions/view-trade-mission/:event_slug/analytics" element={<TradeMissionAnalytics />} />
      <Route path="media/conferences-trade-missions/attendees" element={<ConferenceTradeAttendees />} />
      <Route path="media/conferences/attendees" element={<ConferenceAttendees />} />
      <Route path="media/trade-missions/attendees" element={<TradeMissionAttendees />} />
      <Route
        path="media/tours"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Tours Management</h1>
            <p>Coming soon...</p>
          </div>
        }
      />
      <Route
        path="media/teams"
        element={
          <div className="p-6">
            <h1 className="text-2xl font-bold">Teams Management</h1>
            <p>Coming soon...</p>
          </div>
        }
      />

      {/* Default redirect to dashboard */}
      <Route path="*" element={<Navigate to="dashboard" replace />} />
    </Routes>
  );
}
